"use client"

import { useNavigate } from "react-router-dom"

export default function CurrentApplication({ application }) {
  const navigate = useNavigate()

  // Check for missing required information
  const hasMissingInformation =
    !application.dob ||
    !application.gender ||
    !application.maritalStatus ||
    !application.qualifications ||
    !application.yearOfCompletion ||
    !application.jobTitle ||
    !application.lastName ||
    !application.firstName ||
    !application.address ||
    !application.age ||
    !application.children ||
    !application.city ||
    !application.email ||
    !application.passportNumber ||
    !application.mobileNumber ||
    !application.zipcode

  // Check for missing documents
  const hasMissingDocuments = application?.qualification?.length === 0 || application?.pteIelts?.length === 0 || application?.passport?.length === 0 || application?.healthInsurance?.length === 0 || application?.coe?.length === 0

  // Determine notification message based on conditions
  let notificationMessage = ""

  if (hasMissingInformation) {
    notificationMessage = "Please complete your personal information to proceed with your application"
  } else if (hasMissingDocuments) {
    notificationMessage = "Please upload all required documents to proceed with your application"
  } else if (application.status === "In-Progress") {
    notificationMessage = "Your application is ready to submit. Please review and submit your application"
  } else if (application.paymentStatus === "Not Paid") {
    notificationMessage = "Please pay your invoice to proceed with your application"
  }else notificationMessage = "Your application is submitted and is under review"

  return (
    <div
      onClick={() => navigate(`/client/applications/form/${application._id}`, {})}
      // onClick={()=>console.log(application)}
      className="bg-[#005787] text-white rounded-lg p-3 md:p-6 space-y-6 cursor-pointer"
    >
      <div className="flex justify-between items-start">
        <div> 
          <h3 className="md:text-xl font-medium">{application.visaCategory} Application</h3>
          <p>{application.countryOfInterest}</p>
        </div>
        <div className="text-right">
          <h4 className="text-xs md:text-sm text-gray-300">Status</h4>
          
          <p className="text-sm md:text-base text-nowrap">{application?.status === "WithdrawnByClient" || application?.status === "Cancelled"
            ? "Cancelled"
            : application?.status === "WithdrawnByAgent"
              ? "Withdrawn"
              : application?.status === "VisaApplied"
                ? "Visa Applied"
              : application?.status || "N/A"}</p>
        </div>
      </div>
      

      {notificationMessage && (
        <div>
          <h4 className="text-xs md:text-sm text-gray-300 mb-1">Notification</h4>
          <p className="text-sm md:text-base">{notificationMessage}</p>
        </div>
      )}
    </div>
  )
}
